import moment from 'moment';
import {
  validationDateTime,
  convertDateToISOFormat,
  convertUnixtTimeToDateTime,
} from '../lib/tools';
import config from '../config';

const appInitialState = {
  codeLists: [],
  currentCodeList: {},
  createRequest: false,
  expireDateTime: '',
  updatableDate: '',
  updateIssueContainer: false,
  expireDateTimeError: false,
};

const { qrcodeUpdatableDays } = config;
const createUpdatableDate = () =>
  moment().add(Number(qrcodeUpdatableDays), 'days').format('YYYY/MM/DD HH:mm');
export default (state = appInitialState, action) => {
  switch (action.type) {
    case 'CREATE_QRCODE': {
      const createRequest = true;
      const updatableDate = createUpdatableDate();
      return {
        ...state,
        ...appInitialState,
        createRequest,
        updatableDate,
      };
    }
    case 'SUCCESS_API_LIST_QRS': {
      const updateIssueContainer = false;
      const codeLists = action.payload.codeList || [];
      const currentCodeList = {};
      const updatableDate = createUpdatableDate();
      return {
        ...state,
        codeLists,
        createRequest: false,
        currentCodeList,
        updateIssueContainer,
        updatableDate,
      };
    }
    case 'SUCCESS_API_GET_QR': {
      const updateIssueContainer = false;
      const currentCodeList = action.payload || {};
      const convertExpiresAt =
        (currentCodeList.expiresAt &&
          convertUnixtTimeToDateTime(currentCodeList.expiresAt)) ||
        '';
      const updatableDate = createUpdatableDate();
      const expireDateTime = updatableDate;
      const expireDateTimeError = false;
      return {
        ...state,
        currentCodeList: { ...currentCodeList, convertExpiresAt },
        createRequest: false,
        updateIssueContainer,
        updatableDate,
        expireDateTime,
        expireDateTimeError,
      };
    }
    case 'UPDATE_QRCODE_EXPIRE_DATE': {
      const updateIssueContainer = false;
      const expireDateTime = action.expireDateTime || '';
      const updatableDate = createUpdatableDate();
      const validateError =
        validationDateTime(expireDateTime) && expireDateTime !== '';
      const expireDateTimeError =
        validateError ||
        (!validateError &&
          moment(convertDateToISOFormat(expireDateTime)).isAfter(
            convertDateToISOFormat(updatableDate),
          ));
      return {
        ...state,
        updateIssueContainer,
        expireDateTimeError,
        expireDateTime,
        updatableDate,
      };
    }
    case 'SUCCESS_API_UPDATE_QR': {
      const updateIssueContainer = true;
      const updatableDate = createUpdatableDate();
      return { ...state, updateIssueContainer, updatableDate };
    }
    default:
      return state;
  }
};
